import { StarDrawer } from "./StarDrawer";
export async function loadStarShape(engine, refresh = true) {
    await engine.addShape("star", new StarDrawer(), refresh);
}
